// @flow

export const BASE_URL = '/app/settings';
export const CREDIT_CARD_URL = '/app/settings/billing?section=card';

export const defaultNotificationMessages = {
  success: 'Your settings have been saved!',
  failure: 'There was an error saving your settings!',
  shouldNotify: true,
};

export const SSOIdentityProviders = ['google'];
